/** Omit ref from RHF field spread when the target component does not use forwardRef. */
export const fieldPropsWithoutRef = <T extends { ref?: unknown }>({ ref: _ref, ...rest }: T) =>
  rest;
